import IEmptyProps from "EmptyProps";
import IEmptyState from "EmptyState";
import AudioSystemComparisonTableItem from "Pages/ProductPricing/AudioSystemComparisonTableItem";
import React from 'react';

export default class AudioSystemComparisonTable extends React.Component<IEmptyProps, IEmptyState> {
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {}
    }

    public render() {
        return (
            <div className="audio-system-comparison-table">
                <AudioSystemComparisonTableItem title="Système standard" isBarak={false} powerValue={1} wattage={800}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre A1" isBarak={true} powerValue={1} wattage={1000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Atrium Charles-de-Koninck" isBarak={false} powerValue={2} wattage={1600}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre A2" isBarak={true} powerValue={2} wattage={2000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre B" isBarak={true} powerValue={3} wattage={3000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre C1" isBarak={true} powerValue={5} wattage={5000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Grand Salon" isBarak={false} powerValue={6} wattage={6000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre C2" isBarak={true} powerValue={9} wattage={9000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre C3" isBarak={true} powerValue={14} wattage={14000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre D1" isBarak={true} powerValue={17} wattage={17000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre D2" isBarak={true} powerValue={21} wattage={21000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre D3" isBarak={true} powerValue={23} wattage={23000}></AudioSystemComparisonTableItem>
                <AudioSystemComparisonTableItem title="Calibre E" isBarak={true} powerValue={27} wattage={27000}></AudioSystemComparisonTableItem>
            </div>
        );
    }
}